import Masonry from "masonry-layout";

const init = () => {
    var msnry = new Masonry( '.masonry', {
        itemSelector: '.photo-list-item-link',
        columnWidth: 340,
        gutter: 10
    });

    return msnry;
}

export default { init };